import PersonalProfilePage from "./PersonalProfilePage";

export default PersonalProfilePage;
